import axios, { AxiosResponse } from "axios"
import { Location } from "./../types/location"





export async function searchLocation(
  prefix: string,
  lang: string = "en",
  city:boolean = undefined
): Promise<AxiosResponse<[Location]>> {
  return axios.get("https://backend.briddgy.com/locations/autocomplete", {
    params: {
      prefix,
      lang,
      city
    },
  })
}

// export async function searchLocation(
//   prefix: string,
//   lang: string = "en"
// ): Promise<AxiosResponse<[ApiLocation]>> {
//   return axios_normal.get("/locations/autocomplete", {
//     params: {
//       prefix,
//       lang,
//     },
//   })
// }
